<div
  class="ticket-card {{ ticket.type_card }} ticket-card--{{ ticketStyle }}
  {{ ticketSize }}
  {{
    ticketStyle === ticketCardStyle.Igaming
      ? ticket.is_available
        ? 'available'
        : 'not-available'
      : ''
  }}"
  [class.is-animated]="isAnimated"
  [class.auto-reveal]="autoReveal"
>
  <div class="ticket-card__content">
    <ng-container
      *ngIf="ticket.type_card === ticketCardType.Win && ticket.image"
    >
      <img [src]="ticket.image" alt="{{ ticket.prize_name }}" />
    </ng-container>
    <ng-container *ngIf="ticketStyle === ticketCardStyle.Igaming">
      <span *ngIf="ticket.is_available" class="available-text">
        <p class="top-line">Win</p>
        <span class="down-line">Now</span>
      </span>
      <span *ngIf="!ticket.is_available" class="not-available-text">
        <p class="top-line">Already</p>
        <span class="down-line">Won</span>
      </span>
    </ng-container>

    <span
      class="credit-text"
      *ngIf="ticket.type_card === ticketCardType.Credit"
      [class.pt-3]="!showTicketNumber"
    >
      <strong>{{ ticket.market_value | gbpCurrency }}</strong>
      Site Credit
    </span>

    <span
      class="loss-text"
      *ngIf="
        ticket.type_card === ticketCardType.Loss &&
        ticketStyle === ticketCardStyle.Default
      "
    >
      {{ ticket.ticket_number }}</span
    >
    <span
      class="loss-text"
      *ngIf="
        ticket.type_card === ticketCardType.Loss &&
        ticketStyle !== ticketCardStyle.Default
      "
    >
      <p class="top-line">No</p>
      <span class="down-line">Win</span>
    </span>
  </div>

  <div
    class="ticket-card__footer"
    *ngIf="
      showTicketNumber &&
      (ticket.type_card !== ticketCardType.Loss ||
        ticketStyle !== ticketCardStyle.Default)
    "
  >
    <ng-container *ngIf="ticketStyle === ticketCardStyle.Igaming">
      {{ paddedTicketNumber }}
    </ng-container>
    <ng-container *ngIf="ticketStyle !== ticketCardStyle.Igaming">
      {{ ticket.ticket_number }}
    </ng-container>
  </div>
</div>
